import { useEffect, useState } from 'react';
import useToastStore from 'stores/toastStore';
import { ToastParams } from 'types/toast';

const useToast = () => {
  const { toasts, add, remove } = useToastStore();
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    return () => {
      ids.forEach((id) => remove(id));
    };
  }, [ids, remove]);

  const addToast = (payload: ToastParams) => {
    const id = add(payload);
    setIds([...ids, id]);
  };

  return { toasts, add: addToast, remove };
};

export default useToast;
